import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/tenant-users?paginate=true`

    if (typeof(params.archived) !== 'undefined' && params.archived !== null) {
      url = `${url}&archived=${params.archived}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ tenantID, memberID }) {
    return authenticated({
      url: `/tenants/${tenantID}/tenant-users/${memberID}`,
      method: 'get'
    })
  },
  store({ tenantID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/tenant-users`,
      method: 'post',
      data
    })
  },
  update({ tenantID, memberID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/tenant-users/${memberID}`,
      method: 'patch',
      data
    })
  },
  destroy({ tenantID, memberID }) {
    return authenticated({
      url: `/tenants/${tenantID}/tenant-users/${memberID}`,
      method: 'delete'
    })
  },
  relateModules({ tenantID, memberID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/tenant-users/${memberID}/modules`,
      method: 'post',
      data
    })
  },
  relateGroups({ tenantID, memberID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/tenant-users/${memberID}/groups`,
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/members.js